export default __webpack_public_path__ + "static/media/courses-white.7f116935.svg";